import { render, staticRenderFns } from "./VariousConcerns.vue?vue&type=template&id=3963e797"
import script from "./VariousConcerns.vue?vue&type=script&lang=js"
export * from "./VariousConcerns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports